import SEO from "../components/SEO";
import { COMPANY } from "../data/site";

export function MentionsLegales() {
    return (
        <>
            <SEO title="Mentions légales" description="Mentions légales du site Portail du Léman — LOSTA TECH." />
            <section className="max-w-[860px] mx-auto px-6 lg:px-10 py-20 prose-invert">
                <div className="divider-tag mb-5">Légal</div>
                <h1 className="font-display text-4xl text-white mb-8">Mentions légales</h1>

                <h2 className="font-display text-2xl text-white mt-8 mb-3">Éditeur du site</h2>
                <p>
                    <strong>LOSTA TECH</strong><br />
                    Enseigne commerciale : Portail du Léman<br />
                    1103 Grand Route<br />
                    01630 Saint-Jean-de-Gonville<br />
                    France
                </p>
                <p>
                    SIREN : 103 764 270<br />
                    SIRET : 103 764 270 00015<br />
                    N° TVA intracommunautaire : FR34 103 764 270
                </p>
                <p>
                    Téléphone (France) : +33 6 10 44 38 64<br />
                    E-mail : info@portailduleman.com
                </p>

                <h2 className="font-display text-2xl text-white mt-8 mb-3">Antenne Suisse</h2>
                <p>
                    <strong>Luxury Signs Sàrl</strong><br />
                    Avenue de Frontenex 8<br />
                    1207 Genève – Suisse<br />
                    CHE-148.379.827<br />
                    Téléphone (Suisse) : +41 76 222 36 03
                </p>

                <h2 className="font-display text-2xl text-white mt-8 mb-3">Hébergement</h2>
                <p>Le site est hébergé par un prestataire d'infrastructure cloud sécurisé.</p>

                <h2 className="font-display text-2xl text-white mt-8 mb-3">Propriété intellectuelle</h2>
                <p>
                    L'ensemble des contenus présents sur ce site (textes, photographies, images, logos, graphismes, vidéos, documents et éléments de conception) est protégé par les lois relatives à la propriété intellectuelle.
                </p>
                <p>
                    Ils sont la propriété exclusive de LOSTA TECH ou de leurs titulaires respectifs. Toute reproduction, représentation, diffusion, adaptation ou exploitation, totale ou partielle, sans autorisation écrite préalable est strictement interdite.
                </p>

                <h2 className="font-display text-2xl text-white mt-8 mb-3">Données personnelles</h2>
                <p>
                    Les informations recueillies via ce site sont destinées exclusivement au traitement des demandes des utilisateurs.
                </p>
                <p>
                    Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition, de limitation et de portabilité de vos données.
                </p>
                <p>
                    Pour toute demande, vous pouvez nous contacter à : <a href="mailto:info@portailduleman.com" className="text-brand-accent hover:underline">info@portailduleman.com</a>
                </p>

                <h2 className="font-display text-2xl text-white mt-8 mb-3">Cookies</h2>
                <p>
                    Le site utilise des cookies nécessaires à son bon fonctionnement ainsi que, le cas échéant, des cookies de mesure d'audience et de performance. Leur utilisation est soumise au consentement de l'utilisateur conformément à la réglementation en vigueur.
                </p>
            </section>
        </>
    );
}

export function Confidentialite() {
    return (
        <>
            <SEO title="Politique de confidentialité" description="Politique de confidentialité de Portail du Léman." />
            <section className="max-w-[860px] mx-auto px-6 lg:px-10 py-20 prose-invert">
                <div className="divider-tag mb-5">Légal</div>
                <h1 className="font-display text-4xl text-white mb-8">Politique de confidentialité</h1>
                <p>Les données collectées via le formulaire de devis sont utilisées uniquement pour répondre à votre demande. Elles ne sont jamais transmises à des tiers à des fins commerciales.</p>
                <h2 className="font-display text-2xl text-white mt-8 mb-3">Vos droits</h2>
                <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour exercer ce droit, contactez-nous à {COMPANY.email}.</p>
                <h2 className="font-display text-2xl text-white mt-8 mb-3">Cookies</h2>
                <p>Ce site utilise uniquement des cookies techniques nécessaires à son fonctionnement.</p>
            </section>
        </>
    );
}
